import React, { memo } from 'react'
import styles from './CommonFullPageLoader.module.scss'
import { BounceLoader } from 'react-spinners'
import { useSelector } from 'react-redux'
import { RootState } from '../../../stores/store'

type Props = {}

const CommonFullPageLoader: React.FC<Props> = memo((props: Props) => {
    const showLoader = useSelector((state: RootState) => state.loader.showLoader)

    return (
        <div className={styles.container} style={
            {
                display: showLoader ? 'flex' : 'none'
            }
        }>
            <BounceLoader size={125} color="var(--customer-primary)"/>
        </div>
    )
})

export default CommonFullPageLoader